import React from 'react'

import { Currency } from 'dinero.js'
import { SoftwareCardSoftwareSetupFragment } from 'generated/resources/graphql'
import moment from 'moment'

import { useCurrentSession } from 'modules/core/hooks/useCurrentSession'
import i18n from 'modules/core/lib/i18n'
import MoneyWithCurrency from 'modules/core/lib/money'

import Card from 'modules/it_management/components/Card'
import { UnionSoftwareType } from 'modules/it_management/lib/software'

interface SoftwareCardProps {
  software: UnionSoftwareType
  children?: React.ReactNode
  softwareSetup: SoftwareCardSoftwareSetupFragment
  currency: Currency
}

const SoftwareCard = ({ children, software, softwareSetup, currency }: SoftwareCardProps) => {
  const month = moment().startOf('month').format('M')
  const cost = softwareSetup.monthlySoftwareCosts.find(
    (cost) => moment(cost.monthlyIndexedDate).month() + 1 === parseInt(month)
  )
  const {
    access: { locale },
  } = useCurrentSession()

  return (
    <Card
      avatar={{ name: software.name, url: software.logoUrl || '' }}
      name={software.name}
      description={
        cost?.costInCents
          ? MoneyWithCurrency({
              amount: cost?.costInCents,
              currency: currency,
              locale,
            })
          : i18n.t('it_management.software_setups.list.card.no_cost')
      }
    >
      {children}
    </Card>
  )
}

export default SoftwareCard
